<template>
	<div id="app">
		<Main />
	</div>
</template>

<script>
import Main from '@/layout/Main'

export default {
	name: 'app',
	components: {
		Main
	}
}


</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';
</style>
